import { useQuery } from "@tanstack/react-query";
import { settingsApi, type SiteSetting } from "@/integrations/mysql/client";

export type { SiteSetting };

export function useSiteSettings() {
  // Shares the same queryKey/queryFn as usePageVisibility — uses `select` to
  // transform the SiteSetting[] array into a key→value map without conflicting.
  const { data: settings, isLoading, refetch } = useQuery({
    queryKey: ['site-settings'],
    queryFn: settingsApi.list,
    select: (rows: SiteSetting[]) => {
      const map: Record<string, string> = {};
      if (Array.isArray(rows)) rows.forEach((s) => { map[s.key] = s.value ?? ''; });
      return map;
    },
    staleTime: 30_000,
  });

  const getSetting = (key: string, defaultValue = '') =>
    settings?.[key] ?? defaultValue;

  return { settings: settings ?? {}, isLoading, refetch, getSetting };
}
